import type { SimpleChanges } from '@angular/core';
import { Component, Input, output } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';
import type { RequisitionOpening } from '@core/requisitions-types';
import {
  AvatarComponent,
  ButtonComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
  OfferStatusIndicatorComponent,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';

import { RequisitionsCommonTextsService } from '../../services/requisitions-common-texts.service';

@Component({
  selector: 'rt-requisitions-hired-candidate-card',
  templateUrl: './requisitions-hired-candidate-card.component.html',
  styleUrls: ['./requisitions-hired-candidate-card.component.less'],
  imports: [
    AvatarComponent,
    ButtonComponent,
    DividerComponent,
    HeadingComponent,
    IconComponent,
    OfferStatusIndicatorComponent,
    RouterModule,
    RtTooltip,
    TruncateComponent,
    TranslatePipe,
  ],
})
export class RequisitionsHiredCandidateCardComponent {
  @Input() public filledOpening: RequisitionOpening;
  @Input() public canViewCandidateProfile: boolean;
  @Input() public canUnassignCandidates: boolean;

  public unassignCandidate = output<number>();

  public candidateDeleted: boolean;

  constructor(private requisitionsCommonTextsService: RequisitionsCommonTextsService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.filledOpening) this.candidateDeleted = this.isCandidateDeleted();
  }

  public displayAnticipatedStartDate(value: string): string {
    return this.requisitionsCommonTextsService.getFormattedAnticipatedStartDate(value);
  }

  public displayOpeningReason(value: string): string {
    return this.requisitionsCommonTextsService.getOpeningReason(value);
  }

  private isCandidateDeleted(): boolean {
    if (!this.filledOpening.placement) return true;
    return !!this.filledOpening.placement.candidate.deletedAt;
  }
}
